import {
    AdminLandingPage,
    AdminLandingPageListItem,
    StorefrontMetric,
    StorefrontMetricsResponse,
} from '@storefronts/common-types'

export enum SortField {
    Name = 'name',
    Metrics = 'metrics',
    UpdatedAt = 'updatedAt',
}

export enum SortDirection {
    Asc = 'asc',
    Desc = 'desc',
}

export enum StorefrontFilter {
    ALL_ACTIVE = 'ALL_ACTIVE',
    WITH_TRAFFIC = 'WITH_TRAFFIC',
    NO_TRAFFIC = 'NO_TRAFFIC',
    ARCHIVED = 'ARCHIVED',
}

export interface StorefrontFilterOption {
    id: StorefrontFilter
    label: string
    description: string
    icon?: React.ElementType
}

export interface MetricData {
    [landingPageHash: string]: number
}

export interface MetricsSelectorProps {
    selectedMetric: StorefrontMetric
    onMetricChange: (metric: StorefrontMetric) => void
    days: number
    onDaysChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
}

export interface TableHeaderProps {
    sortField: SortField
    sortDirection: SortDirection
    onSort: (field: SortField) => void
    selectedMetric: StorefrontMetric
}

export interface TableControlsProps {
    searchQuery: string
    onSearchChange: (value: string) => void
    selectedFilter: StorefrontFilter
    onFilterChange: (filter: StorefrontFilter) => void
    selectedMetric: StorefrontMetric
    onMetricChange: (metric: any) => void
    days: number
    onDaysChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
    filterCounts: Map<StorefrontFilter, number>
}

export interface LandingPagesTableProps {
    landingPages: AdminLandingPage[]
}

export type LandingPageTableRow = AdminLandingPageListItem & {
    metrics?: StorefrontMetricsResponse['metrics']
    metricLoadingError?: boolean
}

export type ContentBlockListType = 'LANDING_PAGE' | 'PDP'
